/**
 * @file: idEquals.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { IdType } from '@euler/model/common';

export const idEquals = (a: IdType, b: IdType) =>
  typeof a === typeof b ? a === b : String(a) === String(b);
